<template>
    <div>
        <header class="container-fluid header" v-bind:class="{ 'd-none': userapp }">
            <div class="row">
                <div class="col-4 col-sm-3 col-md-2 text-center">
                    <router-link to="/">
                    <img src="./../../assets/logo-miraflores.png" width="100px" class="img-fluid">
                    </router-link>
                </div>
                <div class="col h1-vecenter">
                    <h1>Plataforma Digital de Atención al Ciudadano</h1>
                </div>
                <div class="d-none d-sm-block col-sm-2 col-md-6 text-right align-middle vcenter content-btn">
                    <div v-if="!$root.$userLogged">
                    <router-link class="btn btn-default" to="/login">Ingresa a tu cuenta</router-link>
                    <router-link class="btn btn-primary" to="/registroUsuarioOption">Regístrate</router-link>
                    </div>
                    <div v-else>
                      <b-dropdown class="desplegable-perfil">
                        <template #button-content>
                          <span class="welcome">
                            <img src="./../../assets/user.png" alt="">
                            ¡Hola {{$root.$nameUser | upper}}!
                          </span>
                        </template>
                        <b-dropdown-item to="/EditarUsuario">Mi perfil</b-dropdown-item>
                        <b-dropdown-item href="javascript:;" @click="logoutInterno()">Cerrar sesión</b-dropdown-item>
                      </b-dropdown>
                    <!-- <a href="javascript:;" @click="logoutInterno()" class="btn btn-primary">Cerrar sesión</a> -->
                    </div>
                </div>
            </div>
            </header>
            <loader v-if="load"></loader>
            <nav class="general" aria-label="breadcrumb" v-if="$root.$userLogged || validaPaginaActual()">
              <div class="container">
                  <ol class="breadcrumb" v-bind:class="{ 'd-none': userapp }">
                  <li class="breadcrumb-item" v-for="(item, index) in title" :key="index">
                      <router-link :to="item.link">
                      {{item.name}}
                      </router-link>
                  </li>
                  </ol>
              </div>
            </nav>
    </div>
</template>
<script>
import Loader from "./../../components/commons/loader"
import GlobalEventBus from './../../helpers/EventBus.js'
import EventBus from './../../helpers/EventBus.js'

export default {
  components: {
    Loader
  },

  created() {
    // console.log("VALOR==================>00000000000000000")
    EventBus.$on('userapp1', (val) => { this.userapp = val })
    
    EventBus.$on('loadershow', (val) => { this.showloader(val) })

  },
  destroyed() {
    // console.log("USERAPP1USERAPP1USERAPP1USERAPP1")
    EventBus.$emit("userapp1", true);
  },
  data() {
    return{
      userapp: false,
      imagen: './assets/logo_miraflores_fblanco.png',
      login:0,
      load: null,
      title: [
        {
          link: "",
          name: "Plataforma"
        }
      ],
      paginaActual:null,
      paginasPermitidas:[
        'pageMultasAdministrativas',
        'pageMultasAdministrativasEstadoCuenta',
        'solicitudInfPublica'        
      ]
    }
  },
  mounted() {
    // console.log("VALOR==================>00000000000000000")
    if (localStorage.getItem("userapp1")==true) {
      this.userapp = true
    }
  },
  methods: {
    showloader(val) {
      this.load = val
    },
    logoutInterno() {
      GlobalEventBus.$emit('logout')
      this.$router.push('/login')
    },
    validaPaginaActual(){
      let valida = false;

      if(this.paginasPermitidas.includes(this.paginaActual)){
        valida = true;
      }

      return valida;
    }
  },
  filters: {
    upper: function (value) {
      if (value) {
       return value.toLowerCase(); 
      }else{
        return ""
      }
      
    }
  },
  watch: {
    '$route' (to, from) {
      // console.log("TOOOOtHEADER",to)
      this.title = to.meta.breadCrumb
      //console.log(to.name)
      this.paginaActual = to.name
    }
  }
}
</script>
<style lang="scss" scope>
  .desplegable-perfil{
    .dropdown-toggle::after {
        display: inline-block;
        margin-left: 0;
        vertical-align: 0.255em;
        content: "";
        border-top: 0.6em solid #0078cf;
        border-right: 0.6em solid transparent;
        border-bottom: 0;
        border-left: 0.6em solid transparent;
    }
    button{
      background: #ff000000 !important;
      color: #212121!important;
      border: none!important;
      &:focus{
        outline: none!important;
        box-shadow: none !important;
      }
    }
    ul.dropdown-menu{
      right: 0px !important;
    }
    .dropdown-item.active, .dropdown-item:active {
        color: #212121;
        background-color: #e7e7e7;
    }
    .dropdown-item {
      padding: 1rem 1.5rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header/HeaderPlataforma.vue